/**
 * Breed lists for Petso Webapp – aligned with Petso Pro Intake Modal.
 * Used by Create Pet Profile (Add Pet) and any other breed dropdowns.
 */

export type BreedEntry = { key: string; label: string };

/** Dog breeds including mixed and crossbreed. */
export const DOG_BREEDS: BreedEntry[] = [
  { key: 'goldenRetriever', label: 'Golden Retriever' },
  { key: 'labrador', label: 'Labrador Retriever' },
  { key: 'germanShepherd', label: 'German Shepherd' },
  { key: 'bulldog', label: 'Bulldog' },
  { key: 'beagle', label: 'Beagle' },
  { key: 'poodle', label: 'Poodle' },
  { key: 'yorkshireTerrier', label: 'Yorkshire Terrier' },
  { key: 'dachshund', label: 'Dachshund' },
  { key: 'boxer', label: 'Boxer' },
  { key: 'frenchBulldog', label: 'French Bulldog' },
  { key: 'siberianHusky', label: 'Siberian Husky' },
  { key: 'australianShepherd', label: 'Australian Shepherd' },
  { key: 'cavalierKingCharlesSpaniel', label: 'Cavalier King Charles Spaniel' },
  { key: 'shihTzu', label: 'Shih Tzu' },
  { key: 'borderCollie', label: 'Border Collie' },
  { key: 'chihuahua', label: 'Chihuahua' },
  { key: 'rottweiler', label: 'Rottweiler' },
  { key: 'dobermanPinscher', label: 'Doberman Pinscher' },
  { key: 'greatDane', label: 'Great Dane' },
  { key: 'pembrokeWelshCorgi', label: 'Pembroke Welsh Corgi' },
  { key: 'australianCattleDog', label: 'Australian Cattle Dog' },
  { key: 'miniatureSchnauzer', label: 'Miniature Schnauzer' },
  { key: 'cockerSpaniel', label: 'Cocker Spaniel' },
  { key: 'shetlandSheepdog', label: 'Shetland Sheepdog' },
  { key: 'bostonTerrier', label: 'Boston Terrier' },
  { key: 'maltese', label: 'Maltese' },
  { key: 'pitBullTerrier', label: 'Pit Bull Terrier' },
  { key: 'vizsla', label: 'Vizsla' },
  { key: 'weimaraner', label: 'Weimaraner' },
  { key: 'berneseMountainDog', label: 'Bernese Mountain Dog' },
  { key: 'englishSpringerSpaniel', label: 'English Springer Spaniel' },
  { key: 'mastiff', label: 'Mastiff' },
  { key: 'pug', label: 'Pug' },
  { key: 'akita', label: 'Akita' },
  { key: 'alaskanMalamute', label: 'Alaskan Malamute' },
  { key: 'bassetHound', label: 'Basset Hound' },
  { key: 'belgianMalinois', label: 'Belgian Malinois' },
  { key: 'bichonFrise', label: 'Bichon Frise' },
  { key: 'bloodhound', label: 'Bloodhound' },
  { key: 'bullTerrier', label: 'Bull Terrier' },
  { key: 'caneCorso', label: 'Cane Corso' },
  { key: 'chesapeakeBayRetriever', label: 'Chesapeake Bay Retriever' },
  { key: 'chowChow', label: 'Chow Chow' },
  { key: 'collie', label: 'Collie' },
  { key: 'dalmatian', label: 'Dalmatian' },
  { key: 'englishBulldog', label: 'English Bulldog' },
  { key: 'goldendoodle', label: 'Goldendoodle' },
  { key: 'greyhound', label: 'Greyhound' },
  { key: 'havanese', label: 'Havanese' },
  { key: 'irishSetter', label: 'Irish Setter' },
  { key: 'jackRussellTerrier', label: 'Jack Russell Terrier' },
  { key: 'keeshond', label: 'Keeshond' },
  { key: 'kingCharlesSpaniel', label: 'King Charles Spaniel' },
  { key: 'komondor', label: 'Komondor' },
  { key: 'kuvasz', label: 'Kuvasz' },
  { key: 'labradoodle', label: 'Labradoodle' },
  { key: 'lhasaApso', label: 'Lhasa Apso' },
  { key: 'miniaturePinscher', label: 'Miniature Pinscher' },
  { key: 'newfoundland', label: 'Newfoundland' },
  { key: 'norwegianElkhound', label: 'Norwegian Elkhound' },
  { key: 'oldEnglishSheepdog', label: 'Old English Sheepdog' },
  { key: 'papillon', label: 'Papillon' },
  { key: 'pekinese', label: 'Pekinese' },
  { key: 'pomeranian', label: 'Pomeranian' },
  { key: 'portugueseWaterDog', label: 'Portuguese Water Dog' },
  { key: 'rhodesianRidgeback', label: 'Rhodesian Ridgeback' },
  { key: 'samoyed', label: 'Samoyed' },
  { key: 'sharPei', label: 'Shar-Pei' },
  { key: 'staffordshireBullTerrier', label: 'Staffordshire Bull Terrier' },
  { key: 'standardSchnauzer', label: 'Standard Schnauzer' },
  { key: 'tibetanTerrier', label: 'Tibetan Terrier' },
  { key: 'westHighlandWhiteTerrier', label: 'West Highland White Terrier' },
  { key: 'whippet', label: 'Whippet' },
  { key: 'mixedBreed', label: 'Mixed Breed' },
  { key: 'crossbreed', label: 'Crossbreed' },
  { key: 'other', label: 'Other' },
];

/** Cat breeds including domestic and mixed. */
export const CAT_BREEDS: BreedEntry[] = [
  { key: 'britishShorthair', label: 'British Shorthair' },
  { key: 'persian', label: 'Persian' },
  { key: 'maineCoon', label: 'Maine Coon' },
  { key: 'siamese', label: 'Siamese' },
  { key: 'ragdoll', label: 'Ragdoll' },
  { key: 'bengal', label: 'Bengal' },
  { key: 'abyssinian', label: 'Abyssinian' },
  { key: 'birman', label: 'Birman' },
  { key: 'oriental', label: 'Oriental' },
  { key: 'devonRex', label: 'Devon Rex' },
  { key: 'sphynx', label: 'Sphynx' },
  { key: 'russianBlue', label: 'Russian Blue' },
  { key: 'scottishFold', label: 'Scottish Fold' },
  { key: 'exoticShorthair', label: 'Exotic Shorthair' },
  { key: 'burmese', label: 'Burmese' },
  { key: 'tonkinese', label: 'Tonkinese' },
  { key: 'himalayan', label: 'Himalayan' },
  { key: 'americanShorthair', label: 'American Shorthair' },
  { key: 'bombay', label: 'Bombay' },
  { key: 'cornishRex', label: 'Cornish Rex' },
  { key: 'manx', label: 'Manx' },
  { key: 'norwegianForestCat', label: 'Norwegian Forest Cat' },
  { key: 'ocicat', label: 'Ocicat' },
  { key: 'savannah', label: 'Savannah' },
  { key: 'selkirkRex', label: 'Selkirk Rex' },
  { key: 'somali', label: 'Somali' },
  { key: 'turkishAngora', label: 'Turkish Angora' },
  { key: 'turkishVan', label: 'Turkish Van' },
  { key: 'domesticShorthair', label: 'Domestic Shorthair' },
  { key: 'domesticLonghair', label: 'Domestic Longhair' },
  { key: 'mixedBreed', label: 'Mixed Breed' },
  { key: 'crossbreed', label: 'Crossbreed' },
  { key: 'other', label: 'Other' },
];

/** Dog breed labels only (for datalist/dropdown). */
export const DOG_BREED_LABELS = DOG_BREEDS.map((b) => b.label);

/** Cat breed labels only. */
export const CAT_BREED_LABELS = CAT_BREEDS.map((b) => b.label);
